<template>
  <router-link :to="{ name: 'index' }">
    <p class="has-text-weight-bold is-size-5" v-html="name"></p>
  </router-link>
</template>

<script>
export default {
  data() {
    return {
      name: process.env.VUE_APP_NAME,
    }
  },
}
</script>
